
<template>
  <el-dialog
    title="个人简历"
    :visible.sync="value"
    width="80%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <h1 v-if="!hasResumeData">
      该用户尚未设置简历.
    </h1>
    <div v-else>
      <el-row class="jianli">
        <el-col :span="12">
          <div class="jianliBox">
            <img
              class="w150"
              :src="getUserImg"
            >

            <div class="info">
              <p>
                <span>{{ profileData.name }}</span>
                <span>{{ profileData.sexDictIdItemName }}</span>
              </p>
              <p>{{ profileData.danWeiMingCheng }}</p>
              <p>
                <span>{{ profileData.buMen }}</span>
                <span>{{ profileData.keShi }}</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="jianliBox">
            <!-- <img class="w150" src="http://116.198.216.54:21021/api/EndUserInfo/LoadUserImage?userId=2"> -->
            <div id="qrCode" ref="qrCodeDiv" />
            <div class="infoTwo">
              <p>
                <span>电话</span>
                {{ profileData.guDingDianHua }}/{{ profileData.phoneNumber }}
              </p>
              <p>
                <span>邮箱</span>
                {{ profileData.emailAddress }}
              </p>
              <p>
                <span>地址</span>
                {{ profileData.tongXunDiZhi }}
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="jianliCont">
        <div class="title01">
          --基本信息--
        </div>

        <el-row>
          <el-col v-if="profileData.nickNameShow" :span="2">昵称：</el-col>
          <el-col v-if="profileData.nickNameShow" :span="10">{{ profileData.nickName }}</el-col>
          <el-col v-if="profileData.birthdayShow" :span="2">出生日期：</el-col>
          <el-col v-if="profileData.birthdayShow" :span="10">{{ profileData.birthdayYMD }}</el-col>
          <el-col v-if="profileData.minZuShow" :span="2">名族：</el-col>
          <el-col v-if="profileData.minZuShow" :span="10">{{ profileData.minZu }}</el-col>
          <el-col v-if="profileData.weiXinBangDingShow" :span="2">微信绑定：</el-col>
          <el-col v-if="profileData.weiXinBangDingShow" :span="10">{{ profileData.weiXinBangDing }}</el-col>
          <el-col v-if="profileData.cardTypeDictIdShow" :span="2">证件类型：</el-col>
          <el-col v-if="profileData.cardTypeDictIdShow" :span="10">{{ profileData.cardTypeDictIdItemName }}</el-col>
          <el-col v-if="profileData.cardNumberShow" :span="2">证件号：</el-col>
          <el-col v-if="profileData.cardNumberShow" :span="10">{{ profileData.cardNumber }}</el-col>
        </el-row>
        <el-row>
          <el-col v-if="profileData.danWeiShengShiShow" :span="2">单位省市：</el-col>
          <el-col v-if="profileData.danWeiShengShiShow" :span="10">{{ profileData.danWeiShengShi }}</el-col>
          <el-col v-if="profileData.danWeiMingChengShow" :span="2">单位名称：</el-col>
          <el-col v-if="profileData.danWeiMingChengShow" :span="10">{{ profileData.danWeiMingCheng }}</el-col>
          <el-col v-if="profileData.tongXunDiZhiShow" :span="2">通讯地址：</el-col>
          <el-col v-if="profileData.tongXunDiZhiShow" :span="10">{{ profileData.tongXunDiZhi }}</el-col>
          <el-col v-if="profileData.youBianShow" :span="2">邮编：</el-col>
          <el-col v-if="profileData.youBianShow" :span="10">{{ profileData.youBian }}</el-col>
          <el-col v-if="profileData.zhiWuShow" :span="2">职务：</el-col>
          <el-col v-if="profileData.zhiWuShow" :span="10">{{ profileData.zhiWu }}</el-col>
          <el-col v-if="profileData.zhiChengXiLieShow" :span="2">职称系列：</el-col>
          <el-col v-if="profileData.zhiChengXiLieShow" :span="10">{{ profileData.zhiChengXiLie }}</el-col>
          <el-col v-if="profileData.suoShuXueKeShow" :span="2">所属学科：</el-col>
          <el-col v-if="profileData.suoShuXueKeShow" :span="10">{{ profileData.suoShuXueKe }}</el-col>
          <el-col v-if="profileData.zhuanYeShow" :span="2">专业：</el-col>
          <el-col v-if="profileData.zhuanYeShow" :span="10">{{ profileData.zhuanYe }}</el-col>
          <el-col v-if="profileData.yanJiuLingYuShow" :span="2">研究领域：</el-col>
          <el-col v-if="profileData.yanJiuLingYuShow" :span="10">{{ profileData.yanJiuLingYu }}</el-col>
          <el-col v-if="profileData.yanJiuFangXiangShow" :span="2">研究方向：</el-col>
          <el-col v-if="profileData.yanJiuFangXiangShow" :span="10">{{ profileData.yanJiuFangXiang }}</el-col>
        </el-row>
        <el-row>
          <el-col v-if="profileData.diYiXueLiDictIdShow" :span="2">第一学历：</el-col>
          <el-col v-if="profileData.diYiXueLiDictIdShow" :span="10">{{ profileData.diYiXueLiDictIdItemName }}</el-col>
          <el-col v-if="profileData.diYiXueWeiDictIdShow" :span="2">第一学位：</el-col>
          <el-col v-if="profileData.diYiXueWeiDictIdShow" :span="10">{{ profileData.diYiXueWeiDictIdItemName }}</el-col>
          <el-col v-if="profileData.zuiGaoXueLiDictIdShow" :span="2">最高学历：</el-col>
          <el-col v-if="profileData.zuiGaoXueLiDictIdShow" :span="10">{{ profileData.zuiGaoXueLiDictIdItemName }}</el-col>
          <el-col v-if="profileData.zuiGaoXueWeiDictIdShow" :span="2">最高学位：</el-col>
          <el-col v-if="profileData.zuiGaoXueWeiDictIdShow" :span="10">{{ profileData.zuiGaoXueWeiDictIdItemName }}</el-col>
          <el-col v-if="profileData.zuiGaoXueWeiShouYuGuoShow" :span="4">最高学位授予国：</el-col>
          <el-col v-if="profileData.zuiGaoXueWeiShouYuGuoShow" :span="8">{{ profileData.zuiGaoXueWeiShouYuGuo }}</el-col>
          <el-col v-if="profileData.isBoShiHouShow" :span="4">是否博士后：</el-col>
          <el-col v-if="profileData.isBoShiHouShow" :span="8">
            <el-checkbox v-model="profileData.isBoShiHou" disabled="" />
          </el-col>
          <el-col v-if="profileData.zfxwXueXiaoShow" :span="4">学校：</el-col>
          <el-col v-if="profileData.zfxwXueXiaoShow" :span="8">{{ profileData.zfxwXueXiao }}</el-col>
          <el-col v-if="profileData.zfxwDaoShiShow" :span="4">导师：</el-col>
          <el-col v-if="profileData.zfxwDaoShiShow" :span="8">{{ profileData.zfxwDaoShi }}</el-col>
          <el-col v-if="profileData.bshGuoBieShow" :span="4">博士后国别：</el-col>
          <el-col v-if="profileData.bshGuoBieShow" :span="8">{{ profileData.bshGuoBie }}</el-col>
          <el-col v-if="profileData.bshDaoShiShow" :span="4">博士后导师：</el-col>
          <el-col v-if="profileData.bshDaoShiShow" :span="8">{{ profileData.bshDaoShi }}</el-col>
          <el-col v-if="profileData.bshKaiShiRiQiShow" :span="4">博士后开始日期：</el-col>
          <el-col v-if="profileData.bshKaiShiRiQiShow" :span="8">{{ profileData.bshKaiShiRiQiYMD }}</el-col>
          <el-col v-if="profileData.bshJieShuRiQiShow" :span="4">博士后结束日期：</el-col>
          <el-col v-if="profileData.bshJieShuRiQiShow" :span="8">{{ profileData.bshJieShuRiQiYMD }}</el-col>
          <el-col v-if="profileData.isYuanShiShow" :span="4">是否院士：</el-col>
          <el-col v-if="profileData.isYuanShiShow" :span="8">
            <el-checkbox v-model="profileData.isYuanShi" disabled="" />
          </el-col>
          <el-col v-if="profileData.yuanShiRuXuanShiJianShow" :span="4">院士入选日期：</el-col>
          <el-col v-if="profileData.yuanShiRuXuanShiJianShow" :span="8">{{ profileData.yuanShiRuXuanShiJianYMD }}</el-col>
        </el-row>
        <el-row>
          <el-col v-if="profileData.isZhongDianRenYuanShow" :span="4">重点实验室人员：</el-col>
          <el-col v-if="profileData.isZhongDianRenYuanShow" :span="8">
            <el-checkbox v-model="profileData.isZhongDianRenYuan" disabled="" />
          </el-col>
          <el-col v-if="profileData.shiYanShiJiBieShow" :span="4">实验室级别：</el-col>
          <el-col v-if="profileData.shiYanShiJiBieShow" :span="8">{{ profileData.shiYanShiJiBie }}</el-col>
          <el-col v-if="profileData.shiYanShiMingChengShow" :span="4">实验室名称：</el-col>
          <el-col v-if="profileData.shiYanShiMingChengShow" :span="8">{{ profileData.shiYanShiMingCheng }}</el-col>
          <el-col v-if="profileData.isCanJiaRenCaiJiHuaShow" :span="4">是否加入人才计划：</el-col>
          <el-col v-if="profileData.isCanJiaRenCaiJiHuaShow" :span="8">
            <el-checkbox v-model="profileData.isCanJiaRenCaiJiHua" disabled="" />
          </el-col>
          <el-col v-if="profileData.zuiGaoRenCaiJiHuaMingChengShow" :span="4">最高人才计划名称：</el-col>
          <el-col v-if="profileData.zuiGaoRenCaiJiHuaMingChengShow" :span="8">{{ profileData.zuiGaoRenCaiJiHuaMingCheng }}</el-col>
          <el-col v-if="profileData.renCaiJiHuaRuXuanShiJianShow" :span="4">人才计划入选时间：</el-col>
          <el-col v-if="profileData.renCaiJiHuaRuXuanShiJianShow" :span="8">{{ profileData.renCaiJiHuaRuXuanShiJianYMD }}</el-col>

        </el-row>
        <el-row>
          <el-col v-if="profileData.geRenJianJieShow" :span="4">简介：</el-col>
          <el-col v-if="profileData.geRenJianJieShow" :span="20">
            <el-input v-model="profileData.geRenJianJie" type="textarea" />
          </el-col>
        </el-row>

        <!-- <table
          cellspacing="0"
          class="jibenxinxin"
        >
          <tr>
            <td>昵称：{{ profileData.nickName }}</td>
            <td>姓氏：{{ profileData.name }}</td>
          </tr>
          <tr>
            <td>名字：{{ profileData.name }}</td>
            <td>证件类型：{{ profileData.name }}</td>
          </tr>
          <tr>
            <td>证件号{{ profileData.name }}</td>
            <td>出生日期{{ profileData.name }}</td>
          </tr>
          <tr>
            <td>名字：{{ profileData.name }}</td>
            <td>证件类型：{{ profileData.name }}</td>
          </tr>
        </table> -->

        <div class="title01">
          --学习经历--
        </div>
        <el-table
          :data="gR0601Data"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="jieShuShiJianShow"
            label="时间"
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.kaiShiShiJianShow }} ~ {{ scope.row.jieShuShiJianShow }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="guoJia"
            label="国家"
          />
          <el-table-column
            prop="xueXiao"
            label="学校"
          />
          <el-table-column
            prop="yuanXi"
            label="院系"
          />
          <el-table-column
            prop="zhuanYe"
            label="专业"
          />
          <el-table-column
            prop="xueWeiDictIdItemName"
            label="学位"
          />
          <el-table-column
            prop="xueZhi"
            label="学制"
          />
          <el-table-column
            prop="daoShi"
            label="导师"
          />
          <el-table-column
            prop="lunWen"
            label="论文"
          />
          <el-table-column
            prop="leiBie"
            label="类别"
          />
        </el-table>

        <div class="title01">
          --工作经历--
        </div>
        <el-table
          :data="gR0602Data"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="kaiShiShiJianShow"
            label="时间"
            width="200px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.kaiShiShiJianShow }} ~ {{ scope.row.jieShuShiJianShow }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="danWeiMingCheng"
            label="单位名称"
          />
          <el-table-column
            prop="buMen"
            label="部门"
          />
          <el-table-column
            prop="chuShi"
            label="处室"
          />
          <el-table-column
            prop="renZhi"
            label="任职"
          />
          <el-table-column
            prop="zhiCheng"
            label="职称"
          />

          <el-table-column
            prop="fenGuanGongZuo"
            label="分管工作"
          />
          <el-table-column
            prop="pingYongXingShi"
            label="聘用形式"
          />
        </el-table>

        <div class="title01">
          --学术任职--
        </div>
        <el-table
          :data="gR0603Data"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="leiXing"
            label="类型"
          />
          <el-table-column
            prop="jiBieDictKeyItemName"
            label="级别"
          />
          <el-table-column
            prop="xueHui"
            label="学会"
          />
          <el-table-column
            prop="zhuanWeiHui"
            label="专委会"
          />
          <el-table-column
            prop="renZhi"
            label="任职"
          />
          <el-table-column
            prop="jieCi"
            label="届次"
          />
          <el-table-column
            prop="fenGuanGongZuo"
            label="分馆工作"
          />
          <el-table-column
            prop="xueHuiJieShao"
            label="学会介绍"
          />
          <el-table-column
            label="时间"
            width="200px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.kaiShiRiQiShow }} ~ {{ scope.row.daoQiRiQiShow }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="title01">
          --荣誉奖项--
        </div>
        <el-table
          :data="gR0604Data"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="chengGuoTiMu"
            label="成果题目"
          />
          <el-table-column
            prop="jiangLiMingCheng"
            label="奖励名称"
          />
          <el-table-column
            prop="jiangLiDengJi"
            label="奖励等级"
          />
          <el-table-column
            prop="leiBie"
            label="类别"
          />
          <el-table-column
            prop="jiangLiJiGou"
            label="奖励机构"
          />
          <el-table-column
            prop="jiangLiRiQiShow"
            label="奖励日期"
          />
          <el-table-column
            prop="zhengShuBianHao"
            label="证书编号"
          />
          <el-table-column
            prop="shuMingWeiCi"
            label="署名位次"
          />
        </el-table>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import config from '@/config'
import QRCode from 'qrcodejs2'
export default {
  components: { },
  props: {
    value: Boolean,
    resumeUserId: { type: Number, default: null },
    resumeKey: { type: Number, default: null }
  },
  data() {
    return {
      title: '个人简历',
      baseURL: config.apiHost,
      hasResumeData: false,
      profileData: {},
      gR0601Data: [],
      gR0602Data: [],
      gR0603Data: [],
      gR0604Data: [],
      qrCodeText: ''
    }
  },
  computed: {
    getUserImg() {
      return this.baseURL + '/api/EndUserInfo/LoadUserImage?userId=' + this.profileData.userId
    }
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  beforeDestroy() {
    if (document.getElementById('qrCode')) {
      document.getElementById('qrCode').innerHTML = ''
    }
  },
  methods: {
    /** 关闭 */
    handleCloseDailog() {
      if (document.getElementById('qrCode')) {
        document.getElementById('qrCode').innerHTML = ''
      }
      this.$emit('input', false)
    },
    /** 打开窗口 */
    handleOpenDailog() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/EndUserInfo/GetJianLiData'
      pathReq
        .getList(path, {
          resumeUserId: that.resumeUserId,
          resumeKey: that.resumeKey
        })
        .then(res => {
          this.profileData = res.data.result.profileData
          this.hasResumeData = res.data.result.hasResumeData
          this.gR0601Data = res.data.result.gR0601Data
          this.gR0602Data = res.data.result.gR0602Data
          this.gR0603Data = res.data.result.gR0603Data
          this.gR0604Data = res.data.result.gR0604Data

          if (!this.hasResumeData) {
            return
          }

          that.qrCodeText = 'MECARD:N:' + that.profileData.name + ';'
          if (that.profileData.phoneNumber) {
            that.qrCodeText += ('TEL:' + that.profileData.phoneNumber + ';')
          }
          if (that.profileData.emailAddress) {
            that.qrCodeText += ('EMAIL:' + that.profileData.emailAddress + ';')
          }
          if (that.profileData.tongXunDiZhi) {
            that.qrCodeText += ('ADR:' + that.profileData.tongXunDiZhi + ';')
          }
          if (that.profileData.danWeiMingCheng) {
            that.qrCodeText += ('ORG:' + that.profileData.danWeiMingCheng + ';')
          }
          this.$nextTick(function() {
            this.bindQRCode()
          })
        }).then(_ => {
          loading.close()
        })
    },
    /** 生成二维码 */
    bindQRCode: function() {
      const that = this
      if (!that.qrCodeText) {
        return
      }
      new QRCode(this.$refs.qrCodeDiv, {
        text: that.qrCodeText,
        width: 100,
        height: 100,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.M// 容错率，L/M/H
      })
    }

  }
}
</script>
<style >

</style>

